/* src/app/order/components/billing-information/billing-information.style.scss */
.billing-container {
  margin: 0 0 40px 0;
}
.billing-container .billing-preferences-container .toggle-details-section {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  text-align: center;
  color: #007d40;
  position: absolute;
  cursor: pointer;
  top: 34px;
  right: 24px;
  text-decoration: none;
}
.billing-container .billing-preferences-container .toggle-details-section nb-icon {
  position: relative;
  top: 2px;
}
.billing-container .billing-preferences-container #card-header {
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.45;
  letter-spacing: normal;
  color: #007d40;
  margin: 0;
  padding-right: 60px;
  display: block;
  max-width: 600px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  hyphens: auto;
}
.billing-container .billing-preferences-container #card-header.collapsed {
  max-width: 600px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.billing-container .billing-preferences-container #billing-details #header {
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.45;
  letter-spacing: normal;
  color: #007d40;
  margin-bottom: 15px;
  margin-top: 30px;
}
/*# sourceMappingURL=billing-information.style.css.map */
